<template>
  <li class="main-tree-node">
    <div
      class="text"
      :class="[treeNodeClass, curPlaceClass, exportClass, parentClass]"
      @dblclick="doubleClick"
      @click="nodeClick"
    >
      <i class="icon" :class="arrowClass" @click.prevent="doubleClick"></i>
      <i :class="[nodeIcon]" class="icon"></i>
      <div v-html="node.text" class="sub-text"></div>
      <span v-if="node.type === 'server'" class="dateInfo">
        edit: {{ getDates.find((date) => date.idServer === node.id).dateEdit }},
        export:
        {{ getDates.find((date) => date.idServer === node.id).dateSave }}</span
      >
      <!-- ----{{node.lId}} ___ {{node.id}} -->
    </div>
    <transition name="leaf">
      <div
        v-if="clicked && node.children && node.children.length > 0"
        class="child-recursive"
      >
        <tree-node
          v-for="(element, index) in node.children"
          :key="index"
          :node="element"
        ></tree-node>
      </div>
    </transition>
  </li>
</template>



<script>
import Form from "./form_elements/Form";
import { mapGetters } from "vuex";
export default {
  name: "tree-node",
  props: ["node"],
  components: { myForm: Form },
  data() {
    return {
      clicked: false,
      formActionType: "",
      childElemType: "",
      formOpen: false,
      treeNodeClass: "",
      //если человек сюда сделал выбор
      curPlaceClass: "",
      deleteDbDialog: false,
      deleteDbRadio: "",
      nodeIcon: "",
      iconColor: "",
      arrowClass: "",
      exportClass: "",
      parentClass: "",
      // popKey: 0
    };
  },
  methods: {
    doubleClick() {
      this.clicked = !this.clicked;
      this.$store.commit("setCurPlaceForExpand", this.node.lId);
      if (this.node.children && this.node.children.length > 0) {
        if (this.clicked) {
          this.arrowClass = "el-icon-caret-bottom";
        } else {
          this.arrowClass = "el-icon-caret-right";
        }
      }
    },
    nodeClick() {
      this.$store.commit("setCurNode", this.node);
      /*  if (
        this.childElemType === "app" ||
        this.childElemType === "server param"
      ) {
        this.$store.commit(
          "setParentId",
          this.node.lId.slice(0, this.node.lId.indexOf("_"))
        );
      }  */ if (
        this.childElemType === "app param" ||
        this.childElemType === "db"
      ) {
        let folderId = this.node.lId.slice(0, this.node.lId.lastIndexOf("_"));
        let finalId = folderId.slice(0, folderId.lastIndexOf("_"));
        if (
          this.node.type === "app param list" ||
          this.node.type === "db list"
        ) {
          finalId = folderId;
        }
        // console.log(folderId, finalId);
        this.$store.commit("setParentId", finalId);
      } else if (this.node.type === "server") {
        this.$store.commit("setParentId", this.node.lId);
      } else {
        this.$store.commit(
          "setParentId",
          this.node.lId.slice(0, this.node.lId.indexOf("_"))
        );
      }
      this.$store.commit("setLoading", false);
    },
    expandTree() {
      let curPlace = this.getCurPlaceForExpand;
      let curNode = this.node.lId;
      let flag = 0;
      if (curNode && curPlace) {
        let curNodeArray = curNode.split("_");
        let curPlaceArray = curPlace.split("_");
        for (let i = 0; i < curNodeArray.length; i++) {
          if (curNodeArray[i] === curPlaceArray[i]) {
            flag++;
          }
        }
        if (flag === curNodeArray.length) {
          this.clicked = true;
          this.arrowClass = "el-icon-caret-bottom";
        }
      }
    },
  },
  created() {
    if (this.node.children && this.node.children.length > 0) {
      this.arrowClass = "el-icon-caret-right";
      this.treeNodeClass = "node";
    } else {
      this.treeNodeClass = "leaf";
    }
    if (this.node.type === "app param list" || this.node.type === "app param") {
      this.childElemType = "app param";
      this.nodeIcon = "";
      if (this.node.type === "app param") this.nodeIcon = "el-icon-check";
      this.iconColor = "param";
    } else if (
      this.node.type === "server param list" ||
      this.node.type === "server param"
    ) {
      this.iconColor = "param";
      this.childElemType = "server param";
      this.nodeIcon = "";
      if (this.node.type === "server param") this.nodeIcon = "el-icon-check";
    } else if (this.node.type === "app list" || this.node.type === "app") {
      this.iconColor = "app";
      this.childElemType = "app";
      this.nodeIcon = "";
    } else if (this.node.type === "server") {
      this.iconColor = "server";
      this.childElemType = "server";
      this.nodeIcon = "el-icon-files";
    } else if (this.node.type === "db" || this.node.type === "db list") {
      this.iconColor = "db";
      this.childElemType = "db";
      this.nodeIcon = "";
      if (this.node.type === "db") this.nodeIcon = "el-icon-coin";
    } else {
      this.childElemType = "smt_else_check";
    }
    this.expandTree();
    if (this.getCurPlace === this.node.lId) {
      this.curPlaceClass = "active";
      this.nodeClick();
    }
  },
  computed: {
    ...mapGetters([
      "getConfigTree",
      "getCurPlace",
      "getCurPlaceForExpand",
      "getParent",
      "getCurInfo",
      "getNotSyncServers",
      "getTypeParam",
      "getDates",
    ]),
  },
  watch: {
    getCurPlace() {
      if (this.getCurPlace === this.node.lId) {
        this.curPlaceClass = "active";
      } else {
        this.curPlaceClass = "";
      }
    },
    clicked() {
      if (this.clicked && this.node.children && this.node.children.length > 0) {
        this.parentClass = "parent-opened";
      } else {
        this.parentClass = "";
      }
    },
    node() {
      if (this.node.children && this.node.children.length > 0) {
        this.arrowClass = "el-icon-caret-right";
        this.treeNodeClass = "node";
      } else {
        this.arrowClass = "";
        this.treeNodeClass = "leaf";
      }
    },
    getNotSyncServers() {
      if (
        this.getNotSyncServers.includes(this.node.id) &&
        this.node.type === "server"
      ) {
        this.exportClass = "not-exported";
      } else {
        this.exportClass = "";
      }
    },
  },
};
</script>




<style scoped>
.leaf-enter-active,
.leaf-leave-active {
  transition: all 0.3s;
}
.leaf-enter,
.leaf-leave-to {
  transform: translateY(-5px);
  /* transform: height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms; */
  opacity: 0;
}
.text {
  line-height: 30px;
  cursor: pointer;
  display: flex;
  border-radius: 5px;
  margin-right: 5px;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}
.text:hover {
  background-color: var(--active-color-lighter);
}

.text.active {
  background-color: var(--active-color-lighter);
}

.text.node {
  font-weight: 500;
}
.text.leaf {
  margin-left: 16px;
}
.text.parent-opened {
  background-color: rgb(248, 248, 248);
}
.text.parent-opened:hover {
  background-color: var(--active-color-lighter);
}
.text.parent-opened.active {
  background-color: var(--active-color-lighter);
}
.icon {
  margin-top: 7px;
  margin-right: 3px;
}
.icon.color {
  color: rgb(128, 128, 128);
}
.server {
  color: rgb(51, 35, 172);
}
.app {
  /* color: rgb(19, 163, 19); */
  color: rgb(0, 97, 0);
}
.db {
  /* color: rgb(248, 47, 47); */
  color: rgb(90, 0, 0);
}
.param {
  color: black;
}
.not-exported {
  color: darkred;
}
.dateInfo {
  font-style: italic;
  font-size: 0.6em;
  margin-left: 10px;
}
</style>